// extracted by mini-css-extract-plugin
module.exports = {"theme":"#DD594A"};